import Skeleton from '@components/skeleton'
import { MdrSectionHeader } from './MdrSectionHeader'
import {
    AlertsCardContent,
    BottomGrid,
    Card,
    ChartArea,
    ChartBlock,
    ListRow,
    ListRows,
    MetricGrid,
    MetricTile,
    SectionContainer,
    SeverityList,
    SeverityRow,
    SkeletonContainer,
    TopGrid,
} from './MdrSkeleton.styles'

const MdrSkeleton = () => {
    return (
        <Skeleton>
            <SkeletonContainer>
                <TopGrid>
                    <SectionContainer>
                        <MdrSectionHeader title="Alerts Overview" />
                        <Card>
                            <AlertsCardContent>
                                <ChartBlock />
                                <SeverityList>
                                    {[1, 2, 3, 4, 5].map((i) => (
                                        <SeverityRow key={i} />
                                    ))}
                                </SeverityList>
                            </AlertsCardContent>
                        </Card>
                    </SectionContainer>
                    <SectionContainer>
                        <MdrSectionHeader title="Incidents Overview" />
                        <Card>
                            <MetricGrid>
                                {[1, 2, 3, 4].map((i) => (
                                    <MetricTile key={i} />
                                ))}
                            </MetricGrid>
                        </Card>
                    </SectionContainer>
                </TopGrid>
                <BottomGrid>
                    <SectionContainer>
                        <MdrSectionHeader title="Open Cases" />
                        <Card>
                            <ListRows>
                                {[1, 2, 3, 4, 5].map((i) => (
                                    <ListRow key={i} />
                                ))}
                            </ListRows>
                        </Card>
                    </SectionContainer>
                    <SectionContainer>
                        <MdrSectionHeader title="Alerts Over Time" />
                        <Card>
                            <ChartArea />
                        </Card>
                    </SectionContainer>
                </BottomGrid>
            </SkeletonContainer>
        </Skeleton>
    )
}

export default MdrSkeleton
